export class DivisaoHonorarios {
    public Id: number;
    public Descricao: string;
    public ProcessoId: number;
    public ClienteId: number;
    public ClienteEscritorioId: number;
    public VencimentoInicial: string;
    public ValorTotal: number;
    public NumeroParcelas: number;
    public ValorPrimeiraParcela: number;
    public ClienteNome: string;
    public ValorPorcentualCliente: number;
    public TipoDRCliente: number;
    public TipoDRClientePagar: number;
    public ValorPorcentualEscritorio: number;
    public TipoDREscritorio: number;
    public PrevisaoDespesaParticipanteId: number;
    public ValorPercentualPrevisaoDespesa: number;
    public TipoDRPrevisaoDespesa: number;
    public ValorPorcentualSubstabelecido: number;
    public SubstabelecidoId: number;
    public TipoDRSubstabelecido: number;
    public TipoDeFornecedor: string;
    public FornecedorId: number;
    public CaixaId: number;
    public Observacao: string;
    public DivisaoHonorariosAdvogado: DivisaoHonorariosAdvogado[];
    public PrestacaoDeContas: boolean;
    public AcordoTrabalhista: boolean;

    constructor() {
        this.TipoDeFornecedor = 'PROCESSO';
        this.ValorTotal = 0;
        this.NumeroParcelas = 1;
        this.ValorPrimeiraParcela = 0.0;
        this.ValorPorcentualCliente = 0;
        this.ValorPorcentualEscritorio = 0;
        this.ValorPercentualPrevisaoDespesa = 0;
        this.ValorPorcentualSubstabelecido = 0;
        this.TipoDRCliente = null;
        this.TipoDRClientePagar = null;
        this.TipoDREscritorio = null;
        this.TipoDRPrevisaoDespesa = null;
        this.TipoDRSubstabelecido = null;
        this.DivisaoHonorariosAdvogado = [];
    }
}

export class DivisaoHonorariosAdvogado {

    public Id: number;
    public DivisaoHonorarioId: number;
    public AdvogadoId: number;
    public TipoDR: number;
    public ValorPorcentual: number;
    public NomeFantasia: string;
    public Desbloqueado: boolean;

    constructor() {
        this.Id = 0;
        this.TipoDR = null;
        this.ValorPorcentual = 0;
    }
}
